import light from '@/theme/light';
import moment from 'moment';
import i18n from '@/locale';

export class ECHandlerBase{

  constructor(){
    this.clear();
  }

  clear(){
    this._option = {};
    return this;
  }

  clearData(){
    return this.clear();
  }

  mergeOption(p_val){
    // _.cloneDeep(_.merge(this._option, p_val));
    _.merge(this._option, p_val);
    return this;
  }

  setDataset(ds_idx, source, dimensions){
    const ds_opt = dimensions ? {source, dimensions} : {source};

    if(undefined == this._option.dataset)
      this._option.dataset = [];

    this._option.dataset[ds_idx] = ds_opt;
    return this;
  }

  setDataset0(source, dimensions){
    return this.setDataset(0, source, dimensions);
  }

  setTitleText(p_val){
    return this.mergeOption({title: {text: p_val}});
  }

  initTitle(){
    return this.mergeOption({title: {
      textStyle: {
        color: '#FFF',
      },
      subtextStyle: {
        align: 'center',
        color: '#FFF',
        fontSize: 16,
      },
    }});
  }

  initTooltip(){
    return this.mergeOption({tooltip: {
      axisPointer: {type: 'shadow'},
      backgroundColor: '#FFF',
      extraCssText: 'z-index:8',
      formatter: '',
      show: true,
      textStyle: {color: 'black'},
      trigger: 'axis',
      triggerOn: 'mousemove',
    }});
  }

  initLegend(){
    return this.mergeOption({legend: {
      left: 'center',
      top: 'bottom',
      textStyle: {color: '#FFF'},
    }});
  }

  buildSeriesByFilter(p_series_type, p_key_name, p_key_values, dimensions, source){

    const tf_list = p_key_values.map(elem => {
      return {transform: {
        type: 'filter',
        config: {dimension: p_key_name, '=': elem},
      }};
    });

    const series = p_key_values.map((elem, idx) => {
      return {...p_series_type, name: elem, datasetIndex: idx + 1, dimensions};
    });
    return this.mergeOption({dataset: [{source}].concat(tf_list), series});
  }
}

export class ECHandlerBarHorizontal extends ECHandlerBase{

  initOption(){
    return this
    .clear()
    .initLegend()
    .initTitle()
    .initTooltip()
    .mergeOption({
      // grid: {left: '14%'},
      xAxis: {
        // name: '',
        type: 'value',
        silent: false,
        axisTick: {show: false},
        axisLine: {
          onZero: true,
          lineStyle: {
            color: 'white',
          },
        },
        splitLine: {show: false},
        splitArea: {show: false},
        // axisLabel: {
        //   color: '#FFF',
        //   formatter: value => {
        //     return `${nFormatter(value, 1)}`;
        //     // return moment(value).format(dateType.BRIEF_DATE);
        //   }
        // },
      },
      yAxis: {
        // name: '',
        type: 'category',
        axisTick: {show: false},
        splitArea: {show: false},
        axisLine: {lineStyle: {color: 'white'}},
        splitLine: {show: false, lineStyle: {color: '#37474F'}},
        axisLabel: {
          show: true,
          color: '#FFF',
        },
      },
    });
  }
}

export class ECHandlerLine extends ECHandlerBase{

  initOption(){
    return this
    .clear()
    .initTitle()
    .initTooltip()
    .mergeOption({
      color: light.color,
      xAxis: {
        // type: 'time',
        type: 'category',
        axisTick: {show: false},
        axisLine: {lineStyle: {color: 'white'}},
        axisLabel: {
          color: '#FFF',
          formatter: value => moment(value).format('MM/DD'),
        },
      },
      yAxis: {
        type: 'value',
        axisTick: {show: false},
        axisLine: {lineStyle: {color: 'white'}},
        axisLabel: {
          color: '#FFF',
          // formatter: value => `${nFormatter(value, 1)}`,
        },
        splitLine: {lineStyle: {color: '#37474F'}},
      },
    });
  }
}

export class ECHandlerPie extends ECHandlerBase{

  initOption(){
    return this
    .clear()
    .initTooltip()
    .mergeOption({
      color: light.color,
      tooltip: {trigger: 'item'},
      legend: {
        show: false,
      },
      series: [
        {
          type: 'pie',
          avoidLabelOverlap: false,
          label: {
            show: false,
          },
          labelLine: {
            show: false,
          },
        },
      ],
    });
  }

  setTooltipFormatterColumnName(p_val){
    return this.mergeOption({tooltip: {formatter: (params) =>
      `${params.marker}${params.name}: ${params.data[p_val]} (${params.percent}%)`
    }});
  }

  buildOption(source, dimensions){
    super.setDataset0(source, dimensions);
    return this.setTooltipFormatterColumnName(dimensions[1]);
  }
}

export class ECHandlerPieDonut extends ECHandlerPie{

  initOption(){
    return super.initOption().mergeOption({series: [{radius: ['50%', '70%']}]});
  }

  setGraphicStyleText(p_title, p_text){
    return this.mergeOption({graphic: {
      type: 'text',
      left: 'center',
      top: 'center',
      style: {
        text: [p_title, p_text].join('\n'),
        fontSize: 16,
        textAlign: 'center',
        textVerticalAlign: 'middle',
        fill: '#fff',
      },
    }});
  }

  buildOption(p_title, p_source, p_dimensions){
    this.initOption();
    super.buildOption(p_source, p_dimensions);
    const col_name = p_dimensions[1];
    let aq_table = g_aq.from(p_source).rollup({
      [col_name]: g_aq.op.sum(col_name),
    });
    return this.setGraphicStyleText(p_title, g_round_off(aq_table.get(col_name)))
  }
}

export class ECHandlerRadar extends ECHandlerBase{

  // initOption(){
  //   return super.initOption().mergeOption({series: [{radius: ['50%', '70%']}]});
  // }

  setRadarIndicator(indicator){
    return this.mergeOption({radar: {indicator}});
  }
}
